import React, { useState } from 'react'
import { Button, Input } from 'antd'

import './index.scss'

let searchThrottle

const GoogleMapsSearch = ({ onSearchAddressSelect }) => {
  const [search, setSearch] = useState('')
  const [results, setResults] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const geoCoder = window.google ? new window.google.maps.Geocoder() : null

  const doSearch = (query) => {
    setIsLoading(true)
    if (geoCoder) {
      geoCoder.geocode({ address: query }, (results, status) => {
        setIsLoading(false)
        if (status === 'OK') {
          setResults(results)
        } else {
          console.log(`Geocode failed:`, status)
        }
      })
    } else {
      console.log('geoCoder is not initialized')
    }
  }

  const throttleSearch = (query) => {
    clearTimeout(searchThrottle)
    searchThrottle = setTimeout(() => doSearch(query), 600)
  }

  const handleSearchFieldUpdate = (e) => {
    const value = e.target.value
    setSearch(value)
    if (value) {
      throttleSearch(value)
    }
  }

  return (
    <>
      <div className="search-wrap">
        <Input.Search
          className="search-field"
          placeholder="Finn sted i kart"
          value={search}
          onChange={handleSearchFieldUpdate}
          style={{ width: 200 }}
          loading={isLoading}
        />
      </div>
      <ul className="results">
        {results.map((result) => {
          const lat = result.geometry.location.lat()
          const lng = result.geometry.location.lng()
          return (
            <li key={result.place_id}>
              <Button
                size="large"
                onClick={() => {
                  onSearchAddressSelect({ lat, lng })
                  setResults([])
                }}
              >
                {result.formatted_address}
              </Button>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default GoogleMapsSearch
